import { createReducer, createActions } from "reduxsauce";
import update from "immutability-helper";
import { IState, ISuccessAction, IFailureAction } from "interfaces/update-duck";

const { Types, Creators } = createActions(
  {
    request: ["id", "putData", "onSuccess", "onFailure"],
    success: [],
    failure: ["error"],
    reset: [],
  },
  { prefix: "DELETE-ORDER_SCHEDULED_ORDER_FOB_" }
);

export interface DeleteOrderScheduledOrderFOBState extends IState {}

const INITIAL_STATE: DeleteOrderScheduledOrderFOBState = {
  loading: false,
  error: null,
};

const request = (state: DeleteOrderScheduledOrderFOBState) =>
  update(state, {
    loading: { $set: true },
    error: { $set: null },
  });

const success = (state: DeleteOrderScheduledOrderFOBState, action: ISuccessAction) =>
  update(state, {
    loading: { $set: false },
  });

const failure = (state: DeleteOrderScheduledOrderFOBState, action: IFailureAction) =>
  update(state, {
    loading: { $set: false },
    error: { $set: action.error },
  });

const reset = () => INITIAL_STATE;

export const deleteOrderScheduledOrderFOB = createReducer(INITIAL_STATE, {
  [Types.REQUEST]: request,
  [Types.SUCCESS]: success,
  [Types.FAILURE]: failure,
  [Types.RESET]: reset,
});

export const DeleteOrderScheduledOrderFOBTypes = Types;
export const DeleteOrderScheduledOrderFOBActions = Creators;
